

<div class="card-content profile-eduction " *ngIf="ShowList">
  <div class="panel-heading">
    <div class="row margin-bottom-13px">
      
        <div class="col-md-4 col-xs-12">
          <div class="row">
            <div class="col-md-2 padding-left-0px padding-right-0px text-align-center margin-top-auto margin-bottom-auto">
              <label for="eventInput5" class="margin-bottom-0px">Date:</label>
            </div>
            <div class="col-md-5 padding-left-0px">
              <div class="date-form">
                <input class="form-control" placeholder="Date" [minDate]="minDate" [maxDate]="maxDate"
                       name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker" required>

                <a (click)="d.toggle()" class="nav-link-hand">
                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                </a>

              </div>
            </div>
          </div>
          

          
        </div>
        <div class="col-md-8 " *ngIf="ShowList">
          <!--<button type="button" (click)="clearData()" class="btn btn-primary btn-sm float-right"> Add New</button>-->
        </div>
     
    </div>
    <div class="row">
      <div class="col-12">
        <!--<h6 class="panel-title fb">Education Info</h6>-->
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table">
              <thead class="profile-thead ">
                <tr>
                  <th>Date</th>
                  <th scope="col"> Physician</th>
                  <th scope="col">Observations</th>
                  <th scope="col">Recommendations</th>
                  <th scope="col">Action</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let l of CurrentActorMedicalFitnessInfoController">
                  <td></td>
                  <td>{{l.CredentialType}}</td>
                  <td>{{l.ValidFrom | date:'MMM-dd-yyyy'}} </td>
                  <td>{{l.AdditionalDetail}}</td>
                  <td>
                    <div class="row">
                      <a (click)="edit_()" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a (click)="del_()" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                     
                    </div>
                  </td>


                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf='IsExpand'>
 
  <div *ngIf='isNew && !ShowList'>
    <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

      <div class="comon-box margin-left-zero p-0">
        <div class="row">
          <div class="col-md-3">
            <h4 class="heading-pinkbg mt-0">Add Observations</h4>
          </div>
          <div class="col-md-9 margin-top-10">

            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand float-right margin-right-10px">Save</button>
            <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right">Cancel</button>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 offset-md-1 text-align-right">
                <label for="diaplayName"><span>*</span> Date</label>
              </div>

              <div class="col-md-2">
                <div class="date-form">
                  <input class="form-control" placeholder="Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker" required>

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>

              </div>
            </div>


          </div>
        </div>
        <div class="row margin-bottom-10px">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right offset-md-1">
                <label for="diaplayName"><span>*</span> Physician</label>
              </div>

              <div class="col-md-3">
                <CodeTypeValue CodeType="Sex">

                </CodeTypeValue>

              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 offset-md-1 text-align-right">
                <label for="diaplayName"> Description</label>
              </div>

              <div class="col-md-4">
                <textarea class="form-control2" rows="2" placeholder="Description"></textarea>

              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 offset-md-1 text-align-right">
                <label for="diaplayName"> Recommendations</label>
              </div>

              <div class="col-md-4">
                <textarea class="form-control2" rows="2" placeholder="Recommendations"></textarea>

              </div>
            </div>


          </div>
        </div>
        <div class="row pl-3 pr-3 margin-left-zero margin-left-zero">


          <!--<div class="form-group col-md-6 col-xs-12">
      <label for="eventInput1"><span>*</span> Physician</label>
      <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorMedicalFitness" id="CurrentActorMedicalFitnessRequest.CredentialTypeCode"
                               [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialTypeCode" name="CurrentActorMedicalFitnessRequest.CredentialTypeCode" required
                               (keyChange)="onCredentialTypeByGroup($event)" #CredentialTypeCode="ngModel">
      </CustomDataByRequestType>
      <small class="form-text text-danger"
             *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>


    </div>-->
          <!--<div class="form-group col-md-6 col-xs-12">
      <label for="eventInput2">Certificate Number</label>
      <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.CredentialNumber" [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialNumber" name="CurrentActorMedicalFitnessRequest.CredentialNumber" placeholder="CredentialNumber">
    </div>-->

          <!--<div class="form-group col-md-6 col-xs-12">
            <label for="eventInput4">Description</label>





          </div>-->



          <!--<div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Recommendations</label>
            
          </div>-->


          <br /><br /><br />  <br /><br /><br />  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

        </div>
      </div>
      <div class="row" >
        <div class="card-footer text-right col-12">
         

        </div>
      </div>
      






    </form>
  </div>
  <div *ngIf='isEdit && !ShowList'>
    <form class="form" novalidate="" (ngSubmit)="onEditSubmit()" #f="ngForm">

      <div class="comon-box p-0 margin-left-zero">
        <div class="row">
          <div class="col-md-3">
            <h4 class="heading-pinkbg mt-0">Update Observations</h4>
          </div>
          <div class="col-md-9 margin-top-10">

            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand float-right margin-right-10px">Update</button>
            <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right">Cancel</button>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 offset-md-1 text-align-right">
                <label for="diaplayName"><span>*</span> Date</label>
              </div>

              <div class="col-md-2">
                <div class="date-form">
                  <input class="form-control" placeholder="Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker" required>

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>

              </div>
            </div>


          </div>
        </div>
        <div class="row margin-bottom-10px">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 text-align-right offset-md-1">
                <label for="diaplayName"><span>*</span> Physician</label>
              </div>

              <div class="col-md-3">
                <CodeTypeValue CodeType="Sex">

                </CodeTypeValue>

              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 offset-md-1 text-align-right">
                <label for="diaplayName"> Description</label>
              </div>

              <div class="col-md-4">
                <textarea class="form-control2" rows="2" placeholder="Description"></textarea>

              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row">
              <div class="col-md-3 offset-md-1 text-align-right">
                <label for="diaplayName"> Recommendations</label>
              </div>

              <div class="col-md-4">
                <textarea class="form-control2" rows="2" placeholder="Recommendations"></textarea>

              </div>
            </div>


          </div>
        </div>
      <div class="row pl-3 pr-3 margin-left-zero margin-left-zero">
      


    <br /><br /><br />  <br /><br /><br />  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
  </div>


      </div>

      <div class="row" *ngIf="CanEdit === 1 ">
        <div class="card-footer text-right col-12">
          <!--<button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>-->

        </div>
      </div>





    </form>
  </div>
</div>



